import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/shared/services/common.service';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import moment from 'moment';
import { BookingSingleDetailsComponent } from 'src/app/bookings/bookings-view/booking-single-details/booking-single-details.component';
import { DrawerService } from 'mis-crystal-design-system/drawer';

@Component({
  selector: 'app-merge-booking-details',
  templateUrl: './merge-booking-details.component.html',
  styleUrls: ['../../../../shared/styles/form.scss', './merge-booking-details.component.scss']
})
export class MergeBookingDetailsComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() bookings: any[];
  @Input() config: any;
  @Input() formDetails: FormGroup;
  @Input() miscelleneousConfig: any;

  @Output() showBookingDetails = new EventEmitter();

  public options: any = {};
  private watchers: any[] = [];
  private selectedCab: any;
  private etsData: any;
  cabOptions: any;
  public loading: boolean;

  constructor(private commonService: CommonService,  private drawerSvc: DrawerService) {
    super();
   }

  ngOnInit() {
    this.loading = true;
    this.commonService.getEtsData().subscribe((response) => {
      this.etsData = response;
      this.setupDropdownOptions();
      this.handleCabChange();
      this.filterCabsOptions();
      this.watchers.push(
        this.formDetails.get('vendor').valueChanges.subscribe(this.handleVendorChange),
        this.formDetails.get('cab').valueChanges.subscribe(this.handleCabChange)
      );
      this.loading = false;
    });
  }

  handleVendorChange = () => {
    const vendorGuid = this.formDetails.get('vendor').value;
    if (this.selectedCab && this.selectedCab.vendor.guid !== vendorGuid) {
      this.selectedCab = null;
      this.formDetails.get('cab').setValue('');
    }
    this.filterCabsOptions();
  }

  handleCabChange = () => {
    const cabGuid = this.formDetails.get('cab').value;
    if (!cabGuid) {
      this.selectedCab = null;
      return;
    }
    for (const cab of this.etsData.cabs) {
      if (cab.guId === cabGuid) {
        this.selectedCab = cab;
        break;
      }
    }
    const vendorGuid = this.formDetails.get('vendor')?.value;
    if ( this.selectedCab && this.selectedCab.vendor && this.selectedCab.vendor.guid && vendorGuid !== this.selectedCab.vendor.guid) {
      this.formDetails.get('vendor').setValue(this.selectedCab.vendor.guid);
    }
  }

  filterCabsOptions() {
    const vendorGuid = this.formDetails.get('vendor').value;
    if (vendorGuid) {
      this.options.cab = [];
      if (this.cabOptions.length > 1) {
        this.options.cab.push({
          name: 'Selected Cabs',
          options: this.filterCabByVendor(this.cabOptions[0].options)
        });
      }
      this.options.cab.push({
        name: 'All Cabs',
        options: this.filterCabByVendor(this.cabOptions[this.cabOptions.length - 1].options)
      });
    } else {
      this.options.cab = this.cabOptions;
    }
  }

  filterCabByVendor(cabs) {
    const vendorGuid = this.formDetails.get('vendor').value;
    return cabs.filter((cab) => {
      if (cab.vendor.guid === vendorGuid) {
        return true;
      }
    });
  }

  setupDropdownOptions() {
    const optionsToMap = ['spotBookingType', 'vehicleType', 'paymentType', 'vendor', 'cab'];
    const optionsAccumalator = {};
    const selectedCabs = [];
    const selectedVendors = [];
    for (const booking of this.bookings) {
      for (const optionToMap of optionsToMap) {
        if (!optionsAccumalator[optionToMap]) {
          optionsAccumalator[optionToMap] = {};
        }
        if (!booking[optionToMap]) {
          continue;
        }
        if (optionToMap === 'vendor') {
          if (!optionsAccumalator[optionToMap][booking[optionToMap].guid]) {
            optionsAccumalator[optionToMap][booking[optionToMap].guid] = true;
            selectedVendors.push(booking.vendor);
          }
        } else if (optionToMap === 'cab') {
          if (!optionsAccumalator[optionToMap][booking[optionToMap].guId]) {
            optionsAccumalator[optionToMap][booking[optionToMap].guId] = true;
            selectedCabs.push(booking.cab);
          }
        } else {
          optionsAccumalator[optionToMap][booking[optionToMap]] = true;
        }
      }
    }

    for (const optionToMap of optionsToMap) {
      this.options[optionToMap] = [];
      const fieldConfig = this.commonService.getConfigForElementKey(this.config, optionToMap);
      if (Object.keys(optionsAccumalator[optionToMap]).length) {
        this.options[optionToMap].push({
          name: `Selected ${fieldConfig.config.displayName}s`,
          options: optionToMap === 'vendor' ? selectedVendors : optionToMap === 'cab' ? selectedCabs :
            Object.keys(optionsAccumalator[optionToMap])
        });
      }
      let allOptions = this.getCompleteOptionList(fieldConfig);
      allOptions = allOptions.filter((option) => {
        if (!optionsAccumalator[optionToMap][this.getOptionValue(option)]) {
          return true;
        }
      });
      this.options[optionToMap].push({
        name: `All ${fieldConfig.config.displayName}s`,
        options: allOptions
      });
    }

    this.cabOptions = this.options['cab'];
  }

  getCompleteOptionList(fieldConfig) {
    if (fieldConfig.config.values && fieldConfig.config.values.length) {
      return fieldConfig.config.values;
    } else if (fieldConfig.elementKey === 'cab') {
      return this.etsData.cabs;
    } else if (fieldConfig.elementKey === 'vendor') {
      return this.etsData.vendors;
    }
  }

  getOptionValue(option) {
    return option.guid || option.guId || option;
  }

  getOptionLabel(option) {
    return option.registration || option.vendorName || option;
  }

  onBookingClick(booking) {
    this.showBookingDetails.emit(booking);
  }

  getDateTime(dateTime) {
    const [datePart, timePart] = dateTime.split(' ');
    const [day, month, year] = datePart.split('/');
    const date = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD');
    const [hour, minute, second] = timePart.split('/');
    const time = moment(`${hour}:${minute}:${second}`, 'HH:mm:ss');
    return date.format('ddd MMM DD, ') + time.format('HH:mm');
  }

  openDetailsSidebar(booking){
    const drawerRef = this.drawerSvc.show(
      BookingSingleDetailsComponent,
      { data: booking,
        miscelleneousConfig: this.miscelleneousConfig,
        showOtpProperty :  this.commonService.workflowConfig['showOTPOnDashboard'] },
      { width: "422px" }
    );
    drawerRef.afterClosed.subscribe();

  }

  ngOnDestroy() {
    this.watchers.forEach((watcher) => {
      watcher.unsubscribe();
    });
  }

}
